import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import {
  IConceptLinkerAiLinker,
  IConceptLinkerAiLinkerCreate,
  IConceptLinkerAiLinkerEdit,
} from 'types/conceptLinkerAiLinker';

export class ConceptLinkerAiLinkerModel extends BaseModel<
  IConceptLinkerAiLinker,
  IConceptLinkerAiLinkerEdit
> {
  courseId: number;

  constructor(options: IModelOptions & { courseId: number }) {
    super(options);
    this.courseId = options.courseId;
    this.ref = IRefIds.conceptLinkerValidator;
    this.gridName = 'ConceptLinkerAiLinker';
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IConceptLinkerAiLinker[]>(
      `concept-linker-ai-linker?courseId=${this.courseId}`,
    );
    this.loadingGrid = false;
    this.render();
  }

  async createJob(data: IConceptLinkerAiLinkerCreate) {
    const response = await post<{ id: number; message: string; items_count: number }>(
      'concept-linker-ai-linker',
      data,
    );
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`concept-linker-ai-linker/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IConceptLinkerAiLinkerEdit>(`concept-linker-ai-linker/${itemId}`);
  }

  async changePriority(itemId: number, priority: number) {
    await put(`/concept-linker-ai-linker/${itemId}/change-priority`, { priority });
  }
}
